import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

export interface CustomModalProps {
  show: boolean
  title: string
  body: string | React.ReactNode
  closeButtonText: string
  okButtonText: string
  handleClose?: () => void
  handleOk?: () => void
}

export const CustomModal = ({
  show,
  title,
  body,
  closeButtonText,
  okButtonText,
  handleClose,
  handleOk
}: CustomModalProps) => {
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {closeButtonText}
          </Button>
          <Button variant="primary" onClick={handleOk}>
            {okButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
